
export enum ClaimExternalStatusCd {
	APPROVED = 'Approved',
	CUSTOMER_CANCELLED = 'CustomerCancelled',
	DECLINED = 'Declined',
	SUBMITTED = 'Submitted',
	UNDER_REVIEW = 'UnderReview',
	UNSUBMITTED = 'Unsubmitted'}

